export const idlFactory = ({ IDL }) => {
  const Role = IDL.Variant({
    'user' : IDL.Null,
    'systemPrompt' : IDL.Null,
    'assistant' : IDL.Null,
  });
  const ChatMessage = IDL.Record({ 'content' : IDL.Text, 'role' : Role });
  const ChatError = IDL.Variant({
    'InvalidInput' : IDL.Text,
    'LlmFailed' : IDL.Text,
    'RateLimited' : IDL.Null,
  });
  const ChatResult = IDL.Variant({ 'ok' : IDL.Text, 'err' : ChatError });
  const ToolInfo = IDL.Record({ 'name' : IDL.Text, 'description' : IDL.Text });
  const Health = IDL.Record({
    'anonymousDailyLimit' : IDL.Nat,
    'authenticatedDailyLimit' : IDL.Nat,
    'oracleWired' : IDL.Bool,
    'llmModel' : IDL.Text,
    'protocolWired' : IDL.Bool,
  });
  return IDL.Service({
    'chat' : IDL.Func([IDL.Vec(ChatMessage)], [ChatResult], []),
    'getToolManifest' : IDL.Func([], [IDL.Vec(ToolInfo)], ['query']),
    'health' : IDL.Func([], [Health], ['query']),
    'installBootstrap' : IDL.Func([IDL.Principal, IDL.Principal], [], []),
    'rateLimitRemaining' : IDL.Func([], [IDL.Nat], ['query']),
  });
};
export const init = ({ IDL }) => { return []; };